import { render, staticRenderFns } from "./BannerGlobal.vue?vue&type=template&id=dc7fa6d0"
import script from "./BannerGlobal.vue?vue&type=script&lang=js"
export * from "./BannerGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default})
